<lib-form-field-container
    [kind]="FormContainerKind.Text"
    [isOptional]="isOptional">

    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>
    <ng-content prefixText select="[prefixText]"></ng-content>
    <ng-content suffixText select="[suffixText]"></ng-content>
    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            <ng-container>{{ formControl.value ?? notSpecifiedString }} </ng-container>
        </div>
    </ng-container>

    <lib-icon-button outsidePrefix
        [icon]="Icon.Common.Remove"
        [kind]="ButtonKind.NeutralTertiary"
        [size]="ButtonSize.Large"
        [debounce]="false"
        [disabled]="minReached"
        [qaTag]="qaTag + '-decrement-icon-button'"
        (clicked)="Decrement()">
    </lib-icon-button>

    <input
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                [attr.aria-label]="ariaLabel || null"
                [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        class="scss-form-field-counter"
        [attr.data-sb-qa]="qaTag"
        [formControl]="viewControl"
        [placeholder]="placeholderText"
        [maxlength]="maxCharacterLength"
        autocomplete="nope"
        inputmode="numeric"
        (blur)="OnBlur()"
        (focus)="OnFocus()"
        (change)="$event.stopPropagation()" />
    <lib-icon-button outsideSuffix
        [icon]="Icon.Common.Add"
        [kind]="ButtonKind.NeutralTertiary"
        [size]="ButtonSize.Large"
        [debounce]="false"
        [disabled]="maxReached"
        [qaTag]="qaTag + '-increment-icon-button'"
        (clicked)="Increment()">
    </lib-icon-button>

</lib-form-field-container>
